import { render } from "./TheBookGroupsIndex.vue?vue&type=template&id=75d845ff&scoped=true"
import script from "./TheBookGroupsIndex.vue?vue&type=script&lang=js"
export * from "./TheBookGroupsIndex.vue?vue&type=script&lang=js"

import "./TheBookGroupsIndex.vue?vue&type=style&index=0&id=75d845ff&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75d845ff"

export default script